

export const columns = [
    { field: 'id', headerName: 'ID', flex: 1, minWidth: 90, hide: true },
    { field: 'category', headerName: 'Catgoría', flex: 1, minWidth: 100 },
    { field: 'equipo_local', headerName: 'Equipo Local', flex: 1, minWidth: 150 },
    { field: 'equipo_visitante', headerName: 'Equipo Visitante', flex: 1, minWidth: 150 },
    { field: 'fecha', headerName: 'Fecha', flex: 1, minWidth: 110 },
    { field: 'hora', headerName: 'Hora', flex: 1, minWidth: 110 },
    { field: 'cancha', headerName: 'Cancha', flex: 1, minWidth: 150 },
    
  ];